<template>
  <!-- NOTE: WorkPackageSubPageModule does not work at all in dummy page -->
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="steering-wheel"
    :header_text_short="'AUTO'/*$t('WorkpackageRework.Info.Log.Header')*/"
    :header_text_long="'AUTO.pilots'/*$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.List')*/"
    @headerBack="$router.push({name: `${location}WorkPackageAutopilots`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #body>
      <div class="work-package-autopilots-details">
        <!-- HEADER -->
        <div class="work-package-autopilots-details-header">
          <TIcon
            :name="getIssueIcon()"
            large
          />
          <div class="work-package-autopilots-details-header-right">
            <!-- AUTOPILOT NAME -->
            <TText
              :text="getAutopilotName(issue.autopilot)"
              :color="workpackage_fg_hex"
              font_weight="400"
              align="left"
              large
            />
            <!-- :text="`${issue.autopilot.function}`" -->
            <!-- ID -->
            <TText
              :text="`ISSUE.date: ${getDateFormatted()}`"
              :color="workpackage_fg_hex"
              align="left"
              small
            />
            <TText
              :text="`ISSUE.id: ${issue.uuid}`"
              :color="workpackage_fg_hex"
              align="left"
              small
            />
            <!-- STATUS -->
            <div class="work-package-autopilots-details-status">
              <TText
                :text="`ISSUE.status:`"
                :color="workpackage_fg_hex"
                small
              />
              <TText
                :text="`${issue.status}`"
                :color="workpackage_fg_hex"
                font_weight="500"
                small
              />
            </div>
          </div>
        </div>

        <!-- LINE -->
        <div class="work-package-autopilots-details-line" :style="`border-color: ${workpackage_fg_hex};`"/>

        <!-- INFO -->
        <TText
          :text="issue.text"
          :color="workpackage_fg_hex"
          align="left"
        />
        <div class="work-package-autopilots-details-button-container">
          <ButtonOutlined
            class="work-package-autopilots-details-button"
            :text="issue.status === 'overruled' ? 'Re-Open' : 'Overrule'"
            :color="workpackage_fg_hex"
            :is_disabled="issue.status === 'resolved'"
            @buttonClicked="show_warning = true"
          />
        </div>

        <!-- Warning Dialogue -->
        <!-- TODO: Translate here -->
        <TransitionAccordion>
          <PopUpOverlay
            v-if="show_warning"
            position_css="transform-origin: center top; margin-top: 8px;"
            @closeOverlay="show_warning = false"
          >
            <template #head>
              <div class="work-package-autopilots-details-warning-head">
                <TIcon
                  name="exclamation-triangle"
                  color="primary"
                />
                <TText
                  text="Warning"
                  medium
                  :font_weight="400"
                  color="primary"
                />
              </div>
            </template>
            <template #body>
              <div class="work-package-autopilots-details-warning-body">
                <TText
                  :text="`Are you sure you want to ${issue.status === 'overruled' ? 're-open' : 'overrule'} this issue?`"
                  medium
                  :font_weight="400"
                  color="primary"
                />
              </div>
            </template>
            <template #additional_v-btn_right>
              <v-btn @click="toggleOverrule()">
                OK
              </v-btn>
            </template>
          </PopUpOverlay>
        </TransitionAccordion>
      </div>
    </template>
  </WorkPackageSubPageModule>
</template>

<script>
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js';
import { mapActions, mapGetters, } from 'vuex';

  export default {
    components: {
      WorkPackageSubPageModule,
      TText,
      TIcon,
      ButtonOutlined,
      PopUpOverlay,
      TransitionAccordion,
    },

    props: [
      'location',
    ],

    mixins: [
      WorkPackageReworkMixin,
    ],

    data: () => ({
      show_warning: false,
      empty: { autopilot: { }, parent: { }}
    }),

    computed: {
      issue(){
        return this.getUObject({type: 'autopilotissues', id: this.$route.params.content_id}) || this.empty;
      },
      ...mapGetters('Autopilot', [
        'getAutopilotName'
      ]),
      ...mapGetters('Ultra', [
        'getUObject'
      ]),
    },

    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
      ]),

      test() {
        console.log("test ok");
      },

      toggleOverrule() {
        this.updateUObject({
            url: [
              { projects: this.project_id },
              { autopilotissues: this.issue.id },
            ],
            update: {
              status: this.issue.status === 'overruled' ? 'open' : 'overruled',
            }
          });
          this.show_warning = false;
      },

      getDateFormatted() {
        let date;
        let s = '';
        if(this.issue.created) {
          date = this.issue.created.substring(0, 10);
        }
        else {
          date = '1970-01-01';
        }

        date = date.split('-'); // date is YYYY-MM-DD
        s += `${date[2]}.`; // day of datum
        s += ' ';
        s += this.$store.state.Ultra.months[date[1].replace(/^[0]+/g,"")]; // month as word in english
        s += ' ';
        s += date[0]; // year

        return s;
      },

      getIssueIcon() {
        switch (this.issue.status) {
          case 'resolved':
            return 'lock-closed';
          case 'overruled':
            return 'lock-closed-warning';
          case 'open':
            return 'lock-open';
          default:
            return 'lock-closed-warning';
        }
      },
    },
  }
</script>

<style>
.work-package-autopilots-details {
  align-items: flex-start;
}
.work-package-autopilots-details-header {
  display: flex;
  flex-direction: row;
  grid-gap: 8px;
  align-items: flex-start;
}
.work-package-autopilots-details-header-right {
  display: flex; flex-direction: column;
}
.work-package-autopilots-details-status {
  display: flex;
  flex-direction: row;
  grid-gap: 4px;
}
.work-package-autopilots-details-line {
  width: 100%;
  margin: 8px 0;
  border-top: 1px solid;
}
.work-package-autopilots-details-button {
  margin-top: 16px;
}
.work-package-autopilots-details-button-container {
  display: flex;
  justify-content: flex-end;
}
.work-package-autopilots-details-warning-head {
  display: flex;
  flex-direction: row;
  grid-gap: 8px;
  align-items: center;
}
.work-package-autopilots-details-warning-body {
  padding-bottom: 8px;
}
</style>
